type Props = {
  mainAxis: number
  crossAxisStart: number
  crossAxisEnd: number
  dotted?: boolean
  orientation: 'vertical' | 'horizontal'
}

export const MeasurementLine = ({ mainAxis, crossAxisStart, crossAxisEnd, dotted = false, orientation }: Props) => {
  const distance = Math.round(Math.abs(crossAxisEnd - crossAxisStart))
  const textCrossAxis = (crossAxisStart + crossAxisEnd) / 2
  const rect =
    orientation === 'vertical'
      ? {
          x: mainAxis - 35,
          y: textCrossAxis - 7.5,
          width: 30,
          height: 15,
        }
      : {
          x: textCrossAxis - 15,
          y: mainAxis - 20,
          width: 30,
          height: 15,
        }
  const textMainAxis = orientation === 'vertical' ? rect.x + rect.width / 2 : rect.y + rect.height / 2 + 5

  return dotted ? (
    <line
      x1={orientation === 'vertical' ? mainAxis : crossAxisStart}
      y1={orientation === 'vertical' ? crossAxisStart : mainAxis}
      x2={orientation === 'vertical' ? mainAxis : crossAxisEnd}
      y2={orientation === 'vertical' ? crossAxisEnd : mainAxis}
      stroke="red"
      strokeWidth="2"
      strokeDasharray="4"
    />
  ) : (
    <>
      <rect x={rect.x} y={rect.y} width={rect.width} height={rect.height} fill="red" />
      <text
        x={orientation === 'vertical' ? textMainAxis : textCrossAxis}
        y={orientation === 'vertical' ? textCrossAxis + 5 : textMainAxis}
        fontSize="12"
        fill="white"
        textAnchor="middle"
      >
        {distance}
      </text>
      <line
        x1={orientation === 'vertical' ? mainAxis : crossAxisStart}
        y1={orientation === 'vertical' ? crossAxisStart : mainAxis}
        x2={orientation === 'vertical' ? mainAxis : crossAxisEnd}
        y2={orientation === 'vertical' ? crossAxisEnd : mainAxis}
        stroke="red"
        strokeWidth="2"
      />
    </>
  )
}
